export const common = {
  loading: 'Carregando…',
  retry: 'Tentar de novo',
  backHome: 'Voltar ao início',
  never: 'Nunca',
  notInformed: 'Não informado',
  lessThanASecond: '<\u00a01\u00a0s',
  close: 'Fechar',
  pageTitle: (page: string, app: string) => `${page} | ${app}`,
} as const
